import { render, staticRenderFns } from "./HealthRecord.vue?vue&type=template&id=25a3491b&scoped=true&"
import script from "./HealthRecord.vue?vue&type=script&lang=js&"
export * from "./HealthRecord.vue?vue&type=script&lang=js&"
import style0 from "./HealthRecord.vue?vue&type=style&index=0&id=25a3491b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25a3491b",
  null
  
)

export default component.exports